// Client-side XLSX exporter for "export what's on screen".
// Usage: exportRowsToXlsx({ filename: "invoices.xlsx", sheetName: "Invoices", columns, rows })
//   columns: [{ key: "invoice_number", label: "No.", format?: (v, row) => string|number }, ...]
//   rows: array of objects
//
// If you pass `rows` directly as an array of arrays (aoa), pass `aoa: true` and skip columns.
import * as XLSX from "xlsx";

export function exportRowsToXlsx({ filename = "export.xlsx", sheetName = "Sheet1", columns, rows, aoa = false }) {
  let ws;
  if (aoa) {
    ws = XLSX.utils.aoa_to_sheet(rows);
  } else {
    const header = columns.map((c) => c.label);
    const body = rows.map((r) => columns.map((c) => {
      const v = typeof c.format === "function" ? c.format(r[c.key], r) : r[c.key];
      if (v === null || v === undefined) return "";
      return v;
    }));
    ws = XLSX.utils.aoa_to_sheet([header, ...body]);
    // Auto column widths
    ws["!cols"] = columns.map((c, i) => {
      const maxLen = Math.max(
        String(c.label || "").length,
        ...body.map((row) => String(row[i] ?? "").length),
      );
      return { wch: Math.min(50, Math.max(8, maxLen + 2)) };
    });
  }
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 30));
  XLSX.writeFile(wb, filename);
}

export function exportMultiSheetXlsx({ filename = "export.xlsx", sheets }) {
  // sheets: [{ name, columns, rows }]
  const wb = XLSX.utils.book_new();
  sheets.forEach((s) => {
    const header = s.columns.map((c) => c.label);
    const body = s.rows.map((r) => s.columns.map((c) => {
      const v = typeof c.format === "function" ? c.format(r[c.key], r) : r[c.key];
      if (v === null || v === undefined) return "";
      return v;
    }));
    const ws = XLSX.utils.aoa_to_sheet([header, ...body]);
    XLSX.utils.book_append_sheet(wb, ws, (s.name || "Sheet").slice(0, 30));
  });
  XLSX.writeFile(wb, filename);
}
